"use strict";
// functions sorted alphabetically
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettyNumber = prettyNumber;
exports.strictParseInt = strictParseInt;
function prettyNumber(value) {
    if (value === 0)
        return '0';
    if (value > 10)
        return Math.round(value).toString();
    if (value > 1)
        return (Math.round(value * 10) / 10).toString();
    return (Math.round(value * 100) / 100).toString();
}
function strictParseInt(value) {
    const parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue) || parsedValue.toString() !== value) {
        throw new Error('Not an integer.');
    }
    else {
        return parsedValue;
    }
}
//# sourceMappingURL=number.js.map